<template>
  <div class="news-content" v-animate-on-scroll="'animate__fadeInUp'">
    <img src="@/assets/images/icon-3.png" alt="" class="icon-image" />
    <div class="news-row">
      <div class="tab-list">
        <img src="@/assets//images/icon-news-1.png" alt="" class="image" />
        <div class="title">新闻中心</div>
        <div class="list-column">
          <div
            class="list-flex"
            v-for="(item, index) in titles"
            :key="index"
            :class="item.isSelected ? 'list-flex-active' : ''"
            @click="handleNewsClick(item)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="more-btn" @click="handleNews(currentTab)">了解更多>></div>
      </div>
      <div class="news-list">
        <div class="news-list-title">
          <div class="name">{{ currentNews.title }}</div>
          <div class="message">{{ currentNews.enginesName }}</div>
        </div>
        <div class="news-list-content">
          <div class="news-list-column">
            <template v-for="(item, index) in newsList">
              <div
                class="list-row"
                v-if="index < 10"
                :key="index"
                @click="toArticleDetail(item)"
              >
                <div class="round"></div>
                <div class="list-name">
                  {{ item.articleName }}
                </div>
                <div class="list-date">[{{ item.releaseTime }}]</div>
              </div>
            </template>
          </div>
          <div class="news-list-column" v-if="newsList.length > 10">
            <template v-for="(item, index) in newsList">
              <div
                class="list-row"
                v-if="index > 9"
                :key="index"
                @click="toArticleDetail(item)"
              >
                <div class="round"></div>
                <div class="list-name">
                  {{ item.articleName }}
                </div>
                <div class="list-date">[{{ item.releaseTime }}]</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticlePage } from '@/api/home/home.js'
export default {
  data() {
    return {
      newsList: [],
      newsBannerList: [], //新闻轮播图列表
      titles: [
        {
          id: 1,
          title: '企业新闻',
          isSelected: true,
          code: '112',
          tabcode: '103',
          enginesName: 'Corporate News'
        },
        {
          id: 2,
          title: '行业资讯',
          isSelected: false,
          code: '113',
          tabcode: '103',
          enginesName: 'Industry News'
        }
      ],
      currentNews: null // 选中的新闻
    }
  },
  created() {
    this.currentNews = this.titles[0]
    this.getArticlePage(112)
  },
  methods: {
    //获取文章列表
    getArticlePage(categoryCode) {
      getArticlePage({
        page: 1,
        limit: 20,
        categoryCode: categoryCode
      }).then((res) => {
        if (!res.data) return
        this.newsList = res.data.list
        this.newsBannerList = this.newsList.map((p) => {
          return {
            bannerUrl: p.cover,
            linkUrl: p.articleId
          }
        })
      })
    },
    // 切换
    handleNewsClick(item) {
      this.titles.forEach((p) => {
        p.isSelected = p.code == item.code ? true : false
      })
      this.currentNews = item
      this.getArticlePage(item.code)
    },
    //   跳转详情
    toArticleDetail(item) {
      if (item.articleUrl) {
        window.open(item.articleUrl)
      } else {
        let url =
          '/articleDetail?categoryId=112&linkType=3&tabcode=103&seccode=112&id=' +
          item.articleId
        this.$router.push(url)
      }
    },

    //   点击了解更多
    handleNews() {
      let url = ''
      if (this.currentNews == null) {
        url = '/imageText?categoryId=112&linkType=3&tabcode=103&seccode=112'
      } else {
        url =
          '/imageText?categoryId=' +
          this.currentNews.code +
          '&linkType=3&tabcode=103&seccode=' +
          this.currentNews.code
      }

      this.$router.push(url)
    }
  }
}
</script>

<style scoped lang="scss">
.news-content {
  display: flex;
  flex-direction: column;
  width: 1340px;
  margin: 64px auto 120px;
  .news-row {
    display: flex;
    flex-direction: row;
    .news-list {
      display: flex;
      flex-direction: column;
      flex: 1;
      .news-list-content {
        display: flex;
        flex-direction: row;
        margin-top: 10px;
        .news-list-column {
          display: flex;
          flex-direction: column;
          flex: 1;
          .list-row {
            display: flex;
            flex-direction: row;
            height: 30px;
            line-height: 30px;
            padding: 0 30px 0 22px;
            margin-top: 24px;
            cursor: pointer;
            .list-date {
              margin-left: 24px;
              color: #999;
              font-size: 16px;
              font-weight: 400;
            }
            .list-name {
              flex: 1;
              margin-left: 14px;
              color: #333;
              font-size: 16px;
              font-weight: 400;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            .round {
              background: #999;
              width: 5px;
              height: 5px;
              margin: auto 0;
              border-radius: 50%;
            }
          }
          .list-row:first-child {
            margin-top: 0;
          }
        }

        .list-row:hover {
          .list-date {
            color: #1b56a9;
          }
          .list-name {
            color: #1b56a9;
            text-decoration: underline;
          }
          .round {
            background: #1b56a9;
          }
        }
      }
      .news-list-title {
        display: flex;
        flex-direction: row;
        height: 54px;
        line-height: 22px;
        padding: 16px;
        box-sizing: border-box;
        border-bottom: 1px solid #e9ebf1;
        .message {
          margin-left: 12px;
          color: #5c5c5c;
          font-size: 16px;
        }
        .name {
          color: #111;
          font-size: 22px;
          font-weight: bold;
        }
      }
    }
    .tab-list {
      display: flex;
      flex-direction: column;
      border-radius: 4px 0 0 4px;
      border: 2px solid #fff;
      background: linear-gradient(180deg, #e7f2ff 8.54%, #fff 106.11%);
      width: 224px;
      height: 622px;
      padding: 40px 24px 16px;
      box-sizing: border-box;
      .more-btn {
        width: 176px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        background-color: #1b56a9;
        color: #fff;
        font-size: 24px;
        font-weight: 500;
        position: absolute;
        bottom: 16px;
        cursor: pointer;
      }
      .list-column {
        display: flex;
        flex-direction: column;
        .list-flex {
          width: 176px;
          height: 53px;
          line-height: 53px;
          margin-top: 12px;
          color: #111;
          font-size: 20px;
          font-weight: bold;
          text-align: center;
          cursor: pointer;
        }
        .list-flex:first-child {
          margin-top: 28px;
        }
        .list-flex-active {
          border-radius: 4px;
          background: rgba(27, 86, 169, 0.12);
          color: #1b56a9;
        }
      }
      .title {
        color: #111;
        font-size: 24px;
        font-weight: 600;
        line-height: 40px;
        text-align: center;
      }
      .image {
        width: 70px;
        height: 70px;
        margin: 0 auto;
      }
    }
  }
  .icon-image {
    width: 250px;
    height: 64px;
    margin: 0 auto 34px;
  }
}

// 手机端css
.mobile-content {
  .news-content {
    width: 375px;
    margin: 32px auto 60px;
    .news-row {
      .news-list {
        .news-list-content {
          margin-top: 8px;
          flex-direction: column;
          .news-list-column {
            .list-row {
              padding: 0 15px 0 11px;
              margin-top: 12px;
              .list-date {
                margin-left: 8px;
                font-size: 13px;
              }
              .list-name {
                font-size: 13px;
                margin-left: 7px;
              }
              .round {
                width: 3px;
                height: 3px;
              }
            }
          }
        }
        .news-list-title {
          height: 30px;
          line-height: 15px;
          padding: 10px;
          .message {
            font-size: 12px;
            margin-left: 6px;
          }
          .name {
            font-size: 14px;
          }
        }
      }
      .tab-list {
        width: 75px;
        padding: 20px 8px 8px;
        box-sizing: border-box;
        .more-btn {
          font-size: 11px;
          border-bottom: 10px;
          width: 56px;
          height: 30px;
          line-height: 30px;
        }
        .list-column {
          margin: 0 auto;
          .list-flex {
            font-size: 12px;
            width: 56px;
            height: 30px;
            line-height: 30px;
            margin-top: 8px;
          }
          .list-flex:first-child {
            margin-top: 14px;
          }
        }
        .title {
          font-size: 12px;
          line-height: 30px;
        }
        .image {
          width: 30px;
          height: 30px;
        }
      }
    }
    .icon-image {
      width: 150px;
      height: 38.4px;
    }
  }
}
</style>
